<template>
    <div >
        <table>
            <tr v-for="(components,componentsIndex) in propsComponentForm" :key="componentsIndex" class="th no-break">   
                <p v-if="typeof components !== 'undefined'" class="is-size-5  th has-text-weight-normal sesstion" :style="indent">{{components.componentName}}</p>
                <div v-if="typeof components !== 'undefined'" >
                    <div v-for="(component,componentDataIndex) in components.componentData" :key="componentDataIndex" :style="indent" class="mg-x-10 ">
                        <FormPrintData
                            :inputValue="inputValue"
                            :component="component"
                        />
                    </div>
                </div>

                <table v-if="typeof inputFormComponent[components.key] !== 'undefined'">
                    <tr v-for="(components,componentsIndex) in inputFormComponent[components.key]" :key="componentsIndex" class="th no-break">   
                        
                        <div v-if="typeof components !== 'undefined'" >
                            <div v-for="(component,componentDataIndex) in components.componentData" :key="componentDataIndex" :style="indent" class="mg-x-10 mg-t-15">
                                <FormPrintData
                                    :inputValue="inputValue"
                                    :component="component"
                                />
                            </div>

                            
                        </div>
                    </tr>
                </table>

                <FormPrint
                    :propsComponentForm="components.children"
                    :depth="depth +1"
                    :inputValue="inputValue"
                    :inputFormComponent="inputFormComponent"
                />
            </tr>
        </table>
    </div>
</template>
<script>
import FormPrintData from './FormPrintData'
export default {
    name:'FormPrint',
    components:{
        FormPrintData
    },
    props:[
        'propsComponentForm',
        'depth',
        'inputValue',
        'inputFormComponent'
    ],
    computed: {
        indent(){
            return {transform:`translate(${this.depth * 20}px)`}
        },
        
    },
    
}
</script>
<style scoped>
i{
    color: #ebebeb;
    font-size: 14px;
}
@page {
  size: A4;
  margin-bottom:  10mm;
  padding-bottom:  10mm;
}

@media print {
    /* table { 
		display: block!important;
		width: 100%;
		page-break-inside: avoid;
	} */
    .no-break{
        page-break-inside: avoid;
    }
    .d-block{
        display: block!important;
        flex-wrap: unset!important;
    }

    .columns:not(.is-desktop){
        display: block!important;
    }
    .is-flex-wrap{
        display: block!important;
        flex-wrap: unset!important;
     }
    .is-flex{
        display: block!important;
    }
    body {margin: 0;}
    p{
        font-size: 14px!important;
    }
    h2{
        font-size: 16px!important;
    }
    .print-mg-auto{
        margin-left:auto!important;
        margin-right:auto!important;
    }
    .detail-table{
        border-radius: 0!important;
        border:0px #fff!important;
    }
    .detail-table, .head-table{
        margin: 0!important;
        
    }
    .page{
        margin: 0 0 80px 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
    }
    .pd-15{
        padding: 0!important;
    }
    .column{
        display: inline-block!important;
        padding-top:0px!important;
        padding-bottom:0px!important;
    }
    .detail-table{
        width: 100%!important;
        border:0px;
        padding:0!important;
    }
}
    .btn-form-add{
        min-width: 130px;
        min-height: 40px;
        border:1px solid #6D8DF3;
        color: #6D8DF3;
        margin: 5px;
    }.sesstion{
        padding: 10px 0px;
        margin: 5px;
        /* background-color: black;
        color: white; */
    }
.td-width{
    width:250px!important;
}
.td-width-date{
    width:250px!important;
}
.td-width-text-area{
    width:250px!important;
}
.table,tr,td{
    border: none!important;
}
.mg-35{
    margin-right: 35px!important;
    word-break: break-all;
}
.mg-x-10{
    margin: -10px 0px;
}
</style>
